import type { DefaultTheme } from 'styled-components';

import * as graphql from '@treams/treams-network';

import { defaultTheme } from './defaultTheme';
import { FONT_FAMILY, tokens } from './tokens';

export const replaceColorsAndFontsInTheme = (
	theme: graphql.WorkspaceTheme,
	defaultColors = defaultTheme,
): DefaultTheme => {
	const updatedColors: Record<string, string> = {
		primary: theme.primaryColor ?? defaultColors.colors.primary,
	};

	const isGradientFilled = theme.linearGradientStart && theme.linearGradientEnd;

	const updatedImages: Record<string, string> = {
		lineGradient: isGradientFilled
			? `linear-gradient(90deg, ${theme.linearGradientStart} 0%, ${theme.linearGradientEnd} 100%)`
			: defaultColors.images.lineGradient,
		logo: theme.logo != null ? theme.logo.source.url : defaultTheme.images.logo,
		loginBackground:
			theme.background != null ? theme.background.source.url : defaultTheme.images.loginBackground,
	};

	return {
		...defaultColors,
		colors: { ...defaultColors.colors, ...updatedColors },
		images: { ...defaultColors.images, ...updatedImages },
		tokens,
		fontFamilies: {
			heading: FONT_FAMILY,
			paragraph: FONT_FAMILY,
		},
	};
};
